import { Dispatch, Action } from 'redux'
import { UserEmailSpanMapDispatchReturnType } from './types/UserEmailSpanMapDispatchReturnType'

export const UserEmailSpanMapDispatch = (
  _dispatch: Dispatch<Action>
): UserEmailSpanMapDispatchReturnType => {
  return {
  }
}
